<template>
  <div>
    <div class="no-print">
      <!-- 列印 -->
      <v-button
        class="mb-2"
        btn-text="列印"
        btnType="primary"
        @click.native="Print"
      />
      <!-- 上一頁 -->
      <v-button
        class="ml-2 mb-2"
        btn-text="返回繳款項目"
        btnType="secondary"
        @click.native="ReturnPublic"
      />
      <!-- WebATM繳款 -->
      <v-button
        class="ml-2 mb-2"
        btn-text="WebATM繳款"
        btnType="warning"
        @click.native="PostWebATM"
      />
      <!-- 複製繳款單號 -->
      <button
        type="button"
        class="btn btn-outline-dark ml-2 mb-2"
        v-clipboard:copy="ShoppayData.PayOrderId"
      >
        點我複製繳費單號:<span id="CopyDebtConfirmNo">{{ ShoppayData.PayOrderId }}</span>
      </button>
    </div>
    <hr class="no-print">
    <!-- PDF -->
    <pdf
      :src="file"
      class="mb-4"
      ref="myPdfComponent"
      style="display: inline-block; width: 80%;"
      @num-pages="pageCount = $event"
      @page-loaded="currentPage = $event"
    />
  </div>
</template>

<script>
import $ from 'jquery'
import pdf from 'vue-pdf'
import { apiFeeorderShoppay } from '../../Api/api'
export default {
  components: {
    pdf
  },
  data () {
    return {
      file: '/Nuk_dists/pdf/' + localStorage.getItem('Filepdf'),
      pageCount: 0,
      currentPage: 0,
      ShoppayData: JSON.parse(localStorage.getItem('Shoppay'))
    }
  },
  created () {
    this.$bus.$emit('Modals', '請依繳費方式按列印或選擇WebATM繳費')
    $('#CheckOk').modal('show')
  },
  methods: {
    Print () { // 列印
      var Durl
      if (window.g.APIServeIP === 'http://10.201.86.159') {
        Durl = window.g.APIServeIP + ':' + window.g.Dport + this.file
      } else if (window.g.Dport === '85') {
        Durl = window.g.APIServeIP + ':' + window.g.Dport + this.file
      } else {
        Durl = window.g.APIServeIP + this.file
      }
      window.open(Durl) // 開新分頁導向PDF，讓使用者列印
      this.PostFeeorderShoppay()
    },
    PostFeeorderShoppay () { // 購物車繳費 F_API 012
      // 定義資料
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      const PayUserData = JSON.parse(localStorage.getItem('PayUserData'))
      const ShoppayData = JSON.parse(localStorage.getItem('Shoppay'))
      const NewData = Object.assign(Identity, ShoppayData, PayUserData)
      // 呼叫API
      apiFeeorderShoppay(NewData).then(
        res => {
          if (res !== undefined) {
            this.$bus.$emit('Modals', res.Msg)
            $('#CheckOk').modal('show')
            return false
          }
        }
      )
    },
    ReturnPublic () {
      this.$router.push({ name: 'Feeorder_Personal' }) // 導向 證件申請頁面
    },
    PostWebATM () { // 導向土地銀行
      // 定義資料
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      const ShoppayData = JSON.parse(localStorage.getItem('Shoppay'))
      const NewData = Object.assign(Identity, ShoppayData)
      // 呼叫API
      apiFeeorderShoppay(NewData).then(
        res => {
          if (res !== undefined) {
            window.open('https://eatm.landbank.com.tw/2008index.aspx', '土地銀行WebATM')
          }
        }
      )
    }
  }
}
</script>
